export const ARPEGGIO_FINGER: ReadonlyArray<number> = Object.freeze([1, 2, 3, 5]);

export function arpeggioPitchClasses(
  pitchClasses: ReadonlyArray<number>,
): number[] {
  if (pitchClasses.length === 0) return [];
  return [...pitchClasses, pitchClasses[0]];
}
